'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'chess-rook';
var width = 448;
var height = 512;
var aliases = [9820];
var unicode = 'f447';
var svgPathData = 'M48 32L32 32l0 16 0 152 0 7.4 5.6 4.8 50 42.9-5.1 97 32 0L120 248.8l.4-7.9-6-5.1L64 192.6 64 64l80 0 0 40 0 16 32 0 0-16 0-40 96 0 0 40 0 16 32 0 0-16 0-40 80 0 0 128.6-50.4 43.2-6 5.1 .4 7.9L333.5 352l32 0-5.1-97 50-42.9 5.6-4.8 0-7.4 0-152 0-16-16 0L48 32zM224 160c-26.5 0-48 21.5-48 48l0 64 0 16 16 0 64 0 16 0 0-16 0-64c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48-32 0 0-48zM64 480l0-9.5L97.8 416l252.4 0L384 470.5l0 9.5L64 480zm304-96L80 384 32 461.3 32 480l0 32 32 0 320 0 32 0 0-32 0-18.7L368 384z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChessRook = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;